import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IQuestionnaireQuestion } from 'src/app/interfaces/Questionnaire/IQuestionnaire';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-mobid-questions',
  templateUrl: './mobid-questions.component.html',
  styleUrl: './mobid-questions.component.css',
  standalone: false,
})
export class MobidQuestionsComponent implements OnInit {
  @Input() elements: IQuestionnaireQuestion[] = [];
  @Input() formGroup!: FormGroup;
  @Input() readonlyMode = false;

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly translate: TranslateService,
    private readonly permissionService: PermissionService,
  ) {}

  ngOnInit(): void {}

  isInpatientView(): boolean {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }

  isEOC(): boolean {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('episodeOfCare')
    );
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  setNotMentioned(fieldName: string): void {
    this.formGroup
      .get(fieldName)
      ?.setValue(this.translate.instant('Not mentioned'));
    this.cdr.detectChanges();
  }

  getQuestionTitle(title?: string): string {
    return title?.split('||')[0]?.trim() ?? '';
  }

  getQuestionInstruction(title?: string): string {
    return title?.split('||')[1]?.trim() ?? '';
  }
}
